import {
	LOAD_TOWJOB_DATA,
	DELETE_A_TOWJOB,
	SAVE_A_TOWJOB,
	UPDATE_A_TOWJOB,
	CLEAR_A_TOWJOB_ERROR_MESSAGE,
	UPLOAD_TOWJOB_PICTURE,
	GET_TOWJOB_PICTURE_IDS,
} from './actions';
import {
	SET_TOW_ENDTIME_FILTER,
	SET_TOW_MAKE_FILTER,
	SET_TOW_PLATE_FILTER,
	SET_TOW_MODEL_FILTER, SET_TOW_STARTTIME_FILTER,
	SET_TOW_STATUS_FILTER,
	SET_TOW_VIN_FILTER,
	SET_TOW_COLOR_FILTER,
	SET_TOW_YEAR_FILTER,
	SET_TOW_CLEAR_ALL_FILTER,
	
} from "./actions";


const initialState = {
	towjobsArray: [],
	towjobsPictureIds: [],
	deleteTowjobResp: {},
	errorCMsg: {},
	saveTowjobResp: {},
	updateTowjobResp: {},
	towStatusFilter: "",
	towMakeFilter: "",
	towVinFilter: "",
	towPlateFilter: "",
	towModelFilter: "",
	towStartTimeFilter: null,
	towEndTimeFilter: null,
	towColorFilter: "",
	towYearFilter: "",
	towUploadResponse: {},
};


export default function reducer(state = initialState, action) {
	switch (action.type) {
		case CLEAR_A_TOWJOB_ERROR_MESSAGE:
			return Object.assign({}, state, {
				errorCMsg: {}
			});
		case UPLOAD_TOWJOB_PICTURE:
			return Object.assign({}, state, {
				towUploadResponse: action.towUploadResponse,
				errorCMsg: action.errorMsg
			});
		case GET_TOWJOB_PICTURE_IDS:
			return Object.assign({}, state, {
				towjobsPictureIds: action.towjobspictureids,
				//errorCMsg: action.errorMsg
			});
		case LOAD_TOWJOB_DATA:
			return Object.assign({}, state, {
				towjobsArray: action.towjobsData
			});
		case DELETE_A_TOWJOB:
			return Object.assign({}, state, {
				deleteTowjobResp: action.deleteTowjobResponse,
				errorCMsg: action.errorMsg
			});
		case SAVE_A_TOWJOB:
			return Object.assign({}, state, {
				saveTowjobResp: action.saveTowjobResponse,
				errorCMsg: action.errorMsg
			});
		case UPDATE_A_TOWJOB:
			return Object.assign({}, state, {
				updateTowjobResp: action.updateTowjobResponse,
				errorCMsg: action.errorMsg
			});
		case SET_TOW_STATUS_FILTER:
			return Object.assign({}, state, {
				towStatusFilter: action.towStatusFilter,
			});
		case SET_TOW_MODEL_FILTER:
			return Object.assign({}, state, {
				towModelFilter: action.towModelFilter,
			});
		case SET_TOW_VIN_FILTER:
			return Object.assign({}, state, {
				towVinFilter: action.towVinFilter,
			});
		case SET_TOW_PLATE_FILTER:
			return Object.assign({}, state, {
				towPlateFilter: action.towPlateFilter,
			});
		case SET_TOW_MAKE_FILTER:
			return Object.assign({}, state, {
				towMakeFilter: action.towMakeFilter,
			});
		case SET_TOW_STARTTIME_FILTER:
			return Object.assign({}, state, {
				towStartTimeFilter: action.towStartTimeFilter,
			});
		case SET_TOW_ENDTIME_FILTER:
			return Object.assign({}, state, {
				towEndTimeFilter: action.towEndTimeFilter,
			});
		
		case SET_TOW_COLOR_FILTER:
			return Object.assign({}, state, {
				towColorFilter: action.towColorFilter,
			});
		case SET_TOW_YEAR_FILTER:
			return Object.assign({}, state, {
				towYearFilter: action.towYearFilter,
			});
		
		case SET_TOW_CLEAR_ALL_FILTER:
			return Object.assign({}, state, {
				towStatusFilter: "",
				towMakeFilter: "",
				towVinFilter: "",
				towPlateFilter: "",
				towModelFilter: "",
				towStartTimeFilter: null,
				towEndTimeFilter: null,
				towColorFilter: "",
				towYearFilter: "",
			});
		
		
		default:
			return state;
	}
}
